export default "__VITE_ASSET__4433f1b7__"